// import uuidV4 from 'uuid/v4';

export const initialValues = {
  id: '',
  dataScadenza: '',
  dataEmissione: '',
  numeroDocumento: '',
  ente: '',
  comune: '',
  provincia: '',
  tipoDocumento: '',
};

export const mapToInitialValues = (newValues) => {
  const mappedValues = {
    dataScadenza: newValues.dataScadenza || '',
    dataEmissione: newValues.dataScadenza || '',
    numeroDocumento: newValues.numeroDocumento || '',
    ente: newValues.ente || '',
    comune: newValues.comune || '',
    provincia: newValues.provincia || '',
    tipoDocumento: newValues.tipoDocumento || '',
  };

  return mappedValues;
};

export default initialValues;



// WEBPACK FOOTER //
// ./app/components/Forms/DocumentoIdentita/initialValues.js